"use strict";

var cov_29o2al7q74 = function () {
  var path = "C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\plugins\\angular-sweetalert.min.js",
      hash = "f9c3f94a48312c8b2b1a80c375a81f364cb80b2b",
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\plugins\\angular-sweetalert.min.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 13
        },
        end: {
          line: 1,
          column: 736
        }
      },
      "1": {
        start: {
          line: 1,
          column: 121
        },
        end: {
          line: 1,
          column: 132
        }
      },
      "2": {
        start: {
          line: 1,
          column: 138
        },
        end: {
          line: 1,
          column: 720
        }
      },
      "3": {
        start: {
          line: 1,
          column: 169
        },
        end: {
          line: 1,
          column: 336
        }
      },
      "4": {
        start: {
          line: 1,
          column: 202
        },
        end: {
          line: 1,
          column: 334
        }
      },
      "5": {
        start: {
          line: 1,
          column: 256
        },
        end: {
          line: 1,
          column: 306
        }
      },
      "6": {
        start: {
          line: 1,
          column: 289
        },
        end: {
          line: 1,
          column: 304
        }
      },
      "7": {
        start: {
          line: 1,
          column: 370
        },
        end: {
          line: 1,
          column: 434
        }
      },
      "8": {
        start: {
          line: 1,
          column: 403
        },
        end: {
          line: 1,
          column: 432
        }
      },
      "9": {
        start: {
          line: 1,
          column: 466
        },
        end: {
          line: 1,
          column: 528
        }
      },
      "10": {
        start: {
          line: 1,
          column: 499
        },
        end: {
          line: 1,
          column: 526
        }
      },
      "11": {
        start: {
          line: 1,
          column: 562
        },
        end: {
          line: 1,
          column: 626
        }
      },
      "12": {
        start: {
          line: 1,
          column: 595
        },
        end: {
          line: 1,
          column: 624
        }
      },
      "13": {
        start: {
          line: 1,
          column: 657
        },
        end: {
          line: 1,
          column: 718
        }
      },
      "14": {
        start: {
          line: 1,
          column: 690
        },
        end: {
          line: 1,
          column: 716
        }
      },
      "15": {
        start: {
          line: 1,
          column: 721
        },
        end: {
          line: 1,
          column: 732
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 91
          },
          end: {
            line: 1,
            column: 92
          }
        },
        loc: {
          start: {
            line: 1,
            column: 111
          },
          end: {
            line: 1,
            column: 733
          }
        },
        line: 1
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 1,
            column: 144
          },
          end: {
            line: 1,
            column: 145
          }
        },
        loc: {
          start: {
            line: 1,
            column: 168
          },
          end: {
            line: 1,
            column: 337
          }
        },
        line: 1
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 1,
            column: 191
          },
          end: {
            line: 1,
            column: 192
          }
        },
        loc: {
          start: {
            line: 1,
            column: 201
          },
          end: {
            line: 1,
            column: 335
          }
        },
        line: 1
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 1,
            column: 236
          },
          end: {
            line: 1,
            column: 237
          }
        },
        loc: {
          start: {
            line: 1,
            column: 255
          },
          end: {
            line: 1,
            column: 307
          }
        },
        line: 1
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 1,
            column: 278
          },
          end: {
            line: 1,
            column: 279
          }
        },
        loc: {
          start: {
            line: 1,
            column: 288
          },
          end: {
            line: 1,
            column: 305
          }
        },
        line: 1
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 1,
            column: 346
          },
          end: {
            line: 1,
            column: 347
          }
        },
        loc: {
          start: {
            line: 1,
            column: 369
          },
          end: {
            line: 1,
            column: 435
          }
        },
        line: 1
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 1,
            column: 392
          },
          end: {
            line: 1,
            column: 393
          }
        },
        loc: {
          start: {
            line: 1,
            column: 402
          },
          end: {
            line: 1,
            column: 433
          }
        },
        line: 1
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 1,
            column: 442
          },
          end: {
            line: 1,
            column: 443
          }
        },
        loc: {
          start: {
            line: 1,
            column: 465
          },
          end: {
            line: 1,
            column: 529
          }
        },
        line: 1
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 1,
            column: 488
          },
          end: {
            line: 1,
            column: 489
          }
        },
        loc: {
          start: {
            line: 1,
            column: 498
          },
          end: {
            line: 1,
            column: 527
          }
        },
        line: 1
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 1,
            column: 538
          },
          end: {
            line: 1,
            column: 539
          }
        },
        loc: {
          start: {
            line: 1,
            column: 561
          },
          end: {
            line: 1,
            column: 627
          }
        },
        line: 1
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 1,
            column: 584
          },
          end: {
            line: 1,
            column: 585
          }
        },
        loc: {
          start: {
            line: 1,
            column: 594
          },
          end: {
            line: 1,
            column: 625
          }
        },
        line: 1
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 1,
            column: 633
          },
          end: {
            line: 1,
            column: 634
          }
        },
        loc: {
          start: {
            line: 1,
            column: 656
          },
          end: {
            line: 1,
            column: 719
          }
        },
        line: 1
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 1,
            column: 679
          },
          end: {
            line: 1,
            column: 680
          }
        },
        loc: {
          start: {
            line: 1,
            column: 689
          },
          end: {
            line: 1,
            column: 717
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 1,
            column: 202
          },
          end: {
            line: 1,
            column: 334
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 1,
            column: 226
          },
          end: {
            line: 1,
            column: 313
          }
        }, {
          start: {
            line: 1,
            column: 314
          },
          end: {
            line: 1,
            column: 334
          }
        }],
        line: 1
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_29o2al7q74.s[0]++;
angular.module("oitozero.ngSweetAlert", []).factory("SweetAlert", ["$rootScope", function ($rootScope) {
  cov_29o2al7q74.f[0]++;
  var _swal = (cov_29o2al7q74.s[1]++, window.swal),
      self = (cov_29o2al7q74.s[2]++, { swal: function swal(arg1, arg2, arg3) {
      cov_29o2al7q74.f[1]++;
      cov_29o2al7q74.s[3]++;
      $rootScope.$evalAsync(function () {
        cov_29o2al7q74.f[2]++;
        cov_29o2al7q74.s[4]++;
        "function" == typeof arg2 ? (cov_29o2al7q74.b[0][0]++, _swal(arg1, function (isConfirm) {
          cov_29o2al7q74.f[3]++;
          cov_29o2al7q74.s[5]++;
          $rootScope.$evalAsync(function () {
            cov_29o2al7q74.f[4]++;
            cov_29o2al7q74.s[6]++;
            arg2(isConfirm);
          });
        }, arg3)) : (cov_29o2al7q74.b[0][1]++, _swal(arg1, arg2, arg3));
      });
    }, success: function success(title, message) {
      cov_29o2al7q74.f[5]++;
      cov_29o2al7q74.s[7]++;
      $rootScope.$evalAsync(function () {
        cov_29o2al7q74.f[6]++;
        cov_29o2al7q74.s[8]++;
        _swal(title, message, "success");
      });
    }, error: function error(title, message) {
      cov_29o2al7q74.f[7]++;
      cov_29o2al7q74.s[9]++;
      $rootScope.$evalAsync(function () {
        cov_29o2al7q74.f[8]++;
        cov_29o2al7q74.s[10]++;
        _swal(title, message, "error");
      });
    }, warning: function warning(title, message) {
      cov_29o2al7q74.f[9]++;
      cov_29o2al7q74.s[11]++;
      $rootScope.$evalAsync(function () {
        cov_29o2al7q74.f[10]++;
        cov_29o2al7q74.s[12]++;
        _swal(title, message, "warning");
      });
    }, info: function info(title, message) {
      cov_29o2al7q74.f[11]++;
      cov_29o2al7q74.s[13]++;
      $rootScope.$evalAsync(function () {
        cov_29o2al7q74.f[12]++;
        cov_29o2al7q74.s[14]++;
        _swal(title, message, "info");
      });
    } });cov_29o2al7q74.s[15]++;
  return self;
}]);